/* Recent The Observatory developments, imported from draft 188974760019.
   The full archive remains a separate, searchable section with a no-JavaScript fallback. */
(() => {
  const root = document.querySelector('[data-mlx]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';
  try {
    build();
  } catch (e) {
    document.documentElement.classList.add('mlx-fallback');
    if (window.console) console.error('The Observatory record view failed; showing the classic archive.', e);
  }

  function build() {
    const D = JSON.parse(root.querySelector('[data-mlx-data]').textContent);
    const mount = root.querySelector('[data-mlx-root]');

    // ---------- helpers
    const h = (tag, cls, text) => { const n = document.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; };
    const DOW = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const MONTH_LONG = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    const parseDay = iso => { const [y, m, d] = iso.split('-').map(Number); const dt = new Date(Date.UTC(y, m - 1, d)); return { y, m, d, dow: DOW[dt.getUTCDay()], mon: MON[m - 1] }; };
    const ext = (a, url) => { a.href = url; a.target = '_blank'; a.rel = 'noopener noreferrer'; return a; };
    const plural = (n, one, many) => n + ' ' + (n === 1 ? one : many);

    const NEWS = ['axios.com', 'techcrunch.com', 'yahoo.com', 'abcnews.com', 'cbsnews.com', 'gizmodo.com', 'qz.com', 'thenextweb.com', 'bloomberglaw.com', '404media.co', 'pbs.org', 'apnews.com', 'scmp.com', 'datacenterdynamics.com', 'thehackernews.com', 'thenationalnews.com', 'theverge.com', 'wired.com', 'ft.com', 'theguardian.com', 'nypost.com', 'sfgate.com', 'wpr.org', 'wtop.com', 'cowboystatedaily.com', 'calmatters.org', 'texastribune.org', 'wisconsinwatch.org', 'hongkongfp.com', 'govinfosecurity.com', 'cybernews.com', 'businessinsider.com', 'dandodiary.com', 'pcworld.com', 'tomsguide.com', 'petapixel.com', 'abc.net.au', 'courthousenews.com', 'research.contrary.com'];
    const RESEARCH = ['arxiv.org', 'unit42.paloaltonetworks.com', 'greynoise.io', 'talosintelligence.com', 'hacktron.ai', 'research.checkpoint.com', 'layerxsecurity.com', 'sysdig.com', 'xlab.qianxin.com', 'longtermresilience.org', 'futureoflife.org', 'semgrep.dev', 'subq.ai'];
    const GOV = ['war.gov', 'europa.eu', 'government.nl', 'un.org', 'gov-pritzker-newsroom.prezly.com', 'agcm.it', 'bankofengland.co.uk', 'nerc.com'];
    const COURT_HOSTS = ['courtlistener.com', 'justia.com', 'myfloridalegal.com'];
    const COURT_PATHS = ['courthousenews.com/wp-content/', 'publishers.org/wp-content/', 'musicbusinessworldwide.com/files/'];
    const SRC_LABEL = { primary: 'Primary', gov: 'Government', court: 'Court filing', news: 'Reported', research: 'Research' };
    const hostOf = url => { try { return new URL(url).hostname.replace(/^www[.]/, ''); } catch (e) { return ''; } };
    const isHost = (host, list) => list.some(d => host === d || host.endsWith('.' + d));
    function srcType(url) {
      const host = hostOf(url);
      if (COURT_PATHS.some(p => url.includes(p)) || isHost(host, COURT_HOSTS)) return 'court';
      if (/[.](gov|mil)$/.test(host) || /[.]gov[.][a-z]{2}$/.test(host) || /[.]gc[.]ca$/.test(host) || isHost(host, GOV)) return 'gov';
      if (isHost(host, NEWS)) return 'news';
      if (isHost(host, RESEARCH)) return 'research';
      return 'primary';
    }
    function badges(url, title) {
      const f = document.createDocumentFragment();
      const t = srcType(url);
      if (t !== 'primary') { const b = h('span', 'mlx-badge', SRC_LABEL[t]); b.dataset.src = t; f.append(b); }
      if (/alleg/i.test(title)) { const a = h('span', 'mlx-badge', 'Allegation'); a.dataset.src = 'alleg'; f.append(a); }
      return f;
    }

    // ---------- data
    const LENS = {};
    D.lenses.forEach(([key, name, line, desc]) => { LENS[key] = { key, name, line, desc }; });
    const E = D.e.map((r, i) => ({ i, date: r[0], title: r[1], org: r[2], url: r[3], verbs: r[4] ? r[4].split(' ') : [] }));
    const TP = D.tp;
    const isTP = i => Object.prototype.hasOwnProperty.call(TP, String(i));
    const verbLabel = e => e.verbs.length ? e.verbs.map(v => LENS[v].name).join(' · ') : 'Context';
    const state = { lens: 'all', q: '' };
    const matchLens = e => state.lens === 'all' || (state.lens === 'context' ? e.verbs.length === 0 : e.verbs.includes(state.lens));
    const norm = s => s.toLowerCase();
    const matchQ = (title, org) => !state.q || norm(title + ' ' + org).includes(state.q);
    const visible = e => matchLens(e) && matchQ(e.title, e.org);

    // The window the JSON covers, so date labels follow the data.
    const first = parseDay(D.days[0][0]), last = parseDay(D.days[D.days.length - 1][0]);
    const longDay = t => MONTH_LONG[t.m - 1] + ' ' + t.d;
    const shortDay = t => t.mon + ' ' + t.d;
    function metaFor(e, withVerbs) {
      const m = h('span', 'mlx-meta');
      m.append(h('span', 'mlx-org', e.org));
      m.append(badges(e.url, e.title));
      if (withVerbs) { const v = h('span', 'mlx-vtags'); v.textContent = verbLabel(e); m.append(v); }
      return m;
    }

    // ---------- pulse: stats + entries per day
    function renderPulse() {
      const p = h('div', 'mlx-pulse mlx-panel');
      const stats = h('div', 'mlx-stats');
      const asof = parseDay(D.asof);
      [[String(D.total), 'developments since 2022'], [String(D.added), 'added since ' + longDay(first)], [asof.mon + ' ' + asof.d + ', ' + asof.y, 'last reviewed']].forEach(([v, l]) => {
        const d = h('div'); d.append(h('strong', null, v), h('span', null, l)); stats.append(d);
      });
      p.append(stats);
      const fig = h('figure', 'mlx-chart');
      const cap = h('figcaption');
      cap.append(h('span', 'mlx-chart-title', 'Entries per day'), h('span', 'mlx-chart-sub', shortDay(first) + ' to ' + shortDay(last) + '. Weekends run light. Select a day to jump to it.'));
      fig.append(cap);
      const max = Math.max(...D.days.map(d => d[1]));
      const top = Math.ceil(max / 5) * 5;
      const plot = h('div', 'mlx-plot');
      const yaxis = h('div', 'mlx-yaxis'); yaxis.setAttribute('aria-hidden', 'true');
      const wrap = h('div', 'mlx-bars-wrap');
      const ticks = []; for (let v = 0; v <= top; v += 5) ticks.push(v);
      ticks.forEach(v => {
        const s = h('span', null, String(v)); s.style.bottom = (v / top * 100) + '%'; yaxis.append(s);
        if (v) { const g = h('div', 'mlx-grid'); g.style.bottom = (v / top * 100) + '%'; wrap.append(g); }
      });
      const bars = h('div', 'mlx-bars');
      bars.setAttribute('role', 'group'); bars.setAttribute('aria-label', 'Entries per day, ' + longDay(first) + ' to ' + longDay(last) + ', ' + last.y);
      const tip = h('div', 'mlx-tip'); tip.setAttribute('aria-hidden', 'true');
      D.days.forEach(([iso, n]) => {
        const t = parseDay(iso);
        const b = h('button', 'mlx-bar'); b.type = 'button'; b.dataset.day = iso;
        const label = t.dow + ', ' + t.mon + ' ' + t.d + ': ' + (n ? plural(n, 'entry', 'entries') : 'no entries');
        b.setAttribute('aria-label', label);
        if (!n) { b.dataset.empty = '1'; b.tabIndex = -1; }
        const i = h('i'); i.style.setProperty('--h', (n / top * 100) + '%'); b.append(i);
        const show = () => {
          tip.textContent = '';
          tip.append(h('b', null, n ? plural(n, 'entry', 'entries') : 'No entries'), h('span', null, t.dow + ', ' + t.mon + ' ' + t.d));
          const br = b.getBoundingClientRect(), wr = wrap.getBoundingClientRect();
          tip.style.left = Math.min(Math.max(br.left - wr.left + br.width / 2, 50), wr.width - 50) + 'px';
          tip.style.top = Math.max(0, (br.bottom - wr.top) - (n / top) * bars.clientHeight - 8) + 'px';
          tip.classList.add('is-on');
        };
        const hide = () => tip.classList.remove('is-on');
        b.addEventListener('pointerenter', show); b.addEventListener('pointerleave', hide);
        b.addEventListener('focus', show); b.addEventListener('blur', hide);
        b.addEventListener('click', () => { if (n) jumpToDay(iso); });
        bars.append(b);
      });
      wrap.append(bars, tip);
      const xaxis = h('div', 'mlx-xaxis'); xaxis.setAttribute('aria-hidden', 'true');
      D.days.forEach(([iso], k) => {
        const t = parseDay(iso);
        if (k === 0 || t.dow === 'Mon') { const s = h('span', k === 0 ? 'is-first' : null, t.mon + ' ' + t.d); s.style.left = (k === 0 ? 0 : ((k + 0.5) / D.days.length * 100)) + '%'; xaxis.append(s); }
      });
      wrap.append(xaxis);
      plot.append(yaxis, wrap);
      fig.append(plot);
      p.append(fig);
      return p;
    }

    // ---------- lens + search
    let lensLine, resultEl, searchLabel, lensBar, chipsEl, legend;
    function renderLens() {
      const kicker = h('p', 'mlx-lens-kicker', 'Explore the recent developments');
      lensBar = h('div', 'mlx-lens');
      const row = h('div', 'mlx-lens-row');
      chipsEl = h('div', 'mlx-chips'); chipsEl.setAttribute('role', 'toolbar'); chipsEl.setAttribute('aria-label', 'Filter recent developments by subject');
      D.lenses.forEach(([key, name]) => {
        if (key === 'context') chipsEl.append(h('span', 'mlx-chip-sep'));
        const b = h('button', 'mlx-chip'); b.type = 'button'; b.dataset.lens = key; b.setAttribute('aria-pressed', key === 'all' ? 'true' : 'false');
        const n = E.filter(e => key === 'all' || (key === 'context' ? !e.verbs.length : e.verbs.includes(key))).length;
        b.append(document.createTextNode(name), h('i', null, String(n)));
        b.addEventListener('click', () => setLens(key));
        chipsEl.append(b);
      });
      row.append(chipsEl);
      searchLabel = h('label', 'mlx-search');
      searchLabel.innerHTML = '<span class="mlx-sr">Search recent titles and sources</span><svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="7"></circle><path d="M20 20l-4-4"></path></svg>';
      const input = h('input'); input.type = 'search'; input.placeholder = 'Search recent entries'; input.autocomplete = 'off';
      searchLabel.append(input);
      let timer = 0;
      input.addEventListener('input', () => { clearTimeout(timer); timer = setTimeout(() => setQuery(input.value), 140); });
      row.append(searchLabel);
      lensBar.append(row);
      lensLine = h('p', 'mlx-lens-line'); lensLine.setAttribute('aria-live', 'polite');
      legend = h('p', 'mlx-legend');
      legend.append(h('span', 'mlx-legend-t', 'Source badges:'));
      [['gov', 'Government'], ['court', 'Court filing'], ['news', 'Reported'], ['research', 'Research'], ['alleg', 'Allegation']].forEach(([k, l]) => { const b = h('span', 'mlx-badge', l); b.dataset.src = k; legend.append(b); });
      legend.append(h('span', null, 'No badge means the organization’s own post.'));
      const mq = matchMedia('(max-width: 720px)');
      const place = () => { (mq.matches ? lensLine : row).append(searchLabel); };
      mq.addEventListener ? mq.addEventListener('change', place) : mq.addListener(place);
      place();
      return [kicker, lensBar, lensLine, legend];
    }
    function updateLensLine(count) {
      const L = LENS[state.lens];
      [...lensLine.childNodes].forEach(n => { if (n !== searchLabel) n.remove(); });
      const em = h('em', null, L.line); const sp = h('span', null, L.desc);
      resultEl = h('b', null, plural(count, 'entry', 'entries') + (state.q ? ' match' : '') + (state.lens === 'all' && !state.q ? ' since ' + shortDay(first) : ''));
      lensLine.prepend(em, sp, resultEl);
    }
    function setLens(key) {
      state.lens = key;
      chipsEl.querySelectorAll('.mlx-chip').forEach(c => c.setAttribute('aria-pressed', c.dataset.lens === key ? 'true' : 'false'));
      const on = chipsEl.querySelector('.mlx-chip[data-lens="' + key + '"]');
      if (on && chipsEl.scrollWidth > chipsEl.clientWidth) chipsEl.scrollTo({ left: Math.max(0, on.offsetLeft - chipsEl.clientWidth / 2 + on.offsetWidth / 2), behavior: 'smooth' });
      apply(true);
    }
    function setQuery(q) {
      state.q = norm(q.trim());
      apply(false);
    }

    // ---------- latest week
    let weekList;
    function renderWeek() {
      const sec = h('section', 'mlx-block mlx-week'); sec.setAttribute('aria-labelledby', 'mlx-week-h');
      const head = h('div', 'mlx-head');
      const ks = Object.keys(D.leads).sort(), w0 = parseDay(ks[0]), w1 = parseDay(ks[ks.length - 1]);
      const range = w0.m === w1.m ? longDay(w0) + ' to ' + w1.d : longDay(w0) + ' to ' + longDay(w1);
      const e1 = h('p', 'mlx-eyebrow', 'Latest week'); const t = h('h3', null, range + ', one headline a day.'); t.id = 'mlx-week-h';
      head.append(e1, t);
      sec.append(head);
      weekList = h('ol', 'mlx-week-days');
      sec.append(weekList);
      return sec;
    }
    function updateWeek() {
      weekList.textContent = '';
      const plain = state.lens === 'all' && !state.q;
      Object.keys(D.leads).sort().reverse().forEach(iso => {
        const day = E.filter(e => e.date === iso);
        const shown = day.filter(visible);
        const t = parseDay(iso);
        const li = h('li', 'mlx-wday');
        const dd = h('span', 'mlx-wday-day'); dd.append(h('b', null, t.dow), document.createTextNode(t.mon + ' ' + t.d));
        li.append(dd);
        const main = h('div', 'mlx-wday-main');
        const lead = plain ? E[D.leads[iso]] : shown[0];
        if (lead) {
          main.append(ext(h('a', 'mlx-wday-lead', lead.title), lead.url), h('span', 'mlx-org', lead.org));
        } else {
          li.classList.add('is-empty');
          main.append(h('span', 'mlx-wday-lead', state.q ? 'No matches this day.' : 'Nothing under ' + LENS[state.lens].name + ' this day.'));
        }
        const more = h('a', 'mlx-wday-more', plain ? plural(day.length, 'entry', 'entries') : shown.length + ' of ' + day.length);
        more.href = '#mlx-d-' + iso;
        more.setAttribute('aria-label', 'All entries for ' + t.dow + ', ' + t.mon + ' ' + t.d);
        more.addEventListener('click', ev => { ev.preventDefault(); jumpToDay(iso); });
        li.append(main, more);
        weekList.append(li);
      });
    }

    // ---------- months: note, turning points, ledger by day
    const monthEls = {};
    function rowFor(e) {
      const li = h('li', 'mlx-row' + (isTP(e.i) ? ' is-tp' : '')); li.dataset.i = e.i;
      const a = ext(h('a', null, e.title), e.url);
      if (isTP(e.i)) a.setAttribute('aria-label', 'Turning point: ' + e.title);
      li.append(a, metaFor(e, true));
      return li;
    }
    function renderMonth(M) {
      const sec = h('section', 'mlx-block mlx-month'); sec.id = 'mlx-m-' + M.key;
      const head = h('header', 'mlx-month-head');
      const total = E.filter(e => e.date.startsWith(M.key)).length;
      const meta = h('p', 'mlx-month-meta'); const cnt = h('b', null, String(total));
      meta.append(document.createTextNode(M.span + ' · '), cnt, document.createTextNode(' entries'));
      head.append(h('h3', null, M.name), meta);
      sec.append(head, h('p', 'mlx-month-note', M.note));
      sec.append(h('p', 'mlx-sub', 'Turning points'));
      const tps = h('div', 'mlx-tps');
      (D.tpOrder[M.key] || []).forEach(i => {
        const e = E[i], t = parseDay(e.date);
        const art = h('article', 'mlx-tp'); art.dataset.i = i;
        const h4 = h('h4'); h4.append(ext(h('a', null, e.title), e.url)); art.append(h4);
        art.append(h('p', 'mlx-tp-date', t.dow + ' · ' + t.mon + ' ' + t.d));
        const why = h('p', 'mlx-why'); why.append(h('span', null, 'Why it matters'), document.createTextNode(TP[String(i)])); art.append(why);
        const foot = h('p', 'mlx-foot'); foot.append(...metaFor(e, true).childNodes); art.append(foot);
        tps.append(art);
      });
      const tpsEmpty = h('p', 'mlx-empty'); tpsEmpty.dataset.hide = '1';
      sec.append(tps, tpsEmpty);
      sec.append(h('p', 'mlx-sub', 'Every entry, by day'));
      const ledger = h('div', 'mlx-ledger'); ledger.id = 'mlx-ledger-' + M.key;
      const days = [...new Set(E.filter(e => e.date.startsWith(M.key)).map(e => e.date))].sort().reverse();
      days.forEach(iso => {
        const t = parseDay(iso);
        // A section[id][tabindex="-1"] so the site's focus helper leaves the scroll position alone after a jump.
        const g = h('section', 'mlx-dgroup'); g.dataset.day = iso; g.id = 'mlx-d-' + iso; g.tabIndex = -1;
        const dh = h('h4', 'mlx-dhead'); dh.id = 'mlx-dh-' + iso; g.setAttribute('aria-labelledby', dh.id);
        const count = h('i');
        dh.append(h('b', null, t.dow), document.createTextNode(t.mon + ' ' + t.d), count);
        const ul = h('ul', 'mlx-rows');
        E.filter(e => e.date === iso).forEach(e => ul.append(rowFor(e)));
        g.append(dh, ul);
        ledger.append(g);
      });
      const empty = h('p', 'mlx-empty'); empty.dataset.hide = '1';
      sec.append(ledger, empty);
      let btn = null;
      if (M.key !== Object.keys(D.tpOrder).sort().reverse()[0]) {
        btn = h('button', 'mlx-more-btn'); btn.type = 'button';
        btn.setAttribute('aria-controls', ledger.id); btn.setAttribute('aria-expanded', 'false');
        btn.addEventListener('click', () => { const open = btn.getAttribute('aria-expanded') !== 'true'; setOpen(M.key, open); if (!open) sec.scrollIntoView({ block: 'start' }); });
        sec.append(btn);
      }
      monthEls[M.key] = { sec, ledger, empty, tps, tpsEmpty, btn, cnt, total, open: !btn };
      return sec;
    }
    function setOpen(key, open) {
      const m = monthEls[key]; if (!m.btn) return;
      m.open = open; m.btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      applyMonth(key);
    }
    function applyMonth(key) {
      const m = monthEls[key];
      const filtering = state.lens !== 'all' || !!state.q;
      let shown = 0;
      m.ledger.querySelectorAll('.mlx-dgroup').forEach(g => {
        let n = 0;
        g.querySelectorAll('.mlx-row').forEach(r => { const ok = visible(E[+r.dataset.i]); if (ok) n++; r.toggleAttribute('data-hide', !ok); });
        g.toggleAttribute('data-hide', n === 0);
        g.querySelector('.mlx-dhead i').textContent = plural(n, 'entry', 'entries');
        shown += n;
      });
      const showLedger = m.open || filtering;
      m.ledger.toggleAttribute('data-hide', !showLedger);
      let tpShown = 0;
      m.tps.querySelectorAll('.mlx-tp').forEach(a => { const ok = visible(E[+a.dataset.i]); a.toggleAttribute('data-hide', !ok); a.classList.toggle('is-lead', ok && tpShown === 0); if (ok) tpShown++; });
      m.tps.toggleAttribute('data-hide', tpShown === 0);
      m.tpsEmpty.toggleAttribute('data-hide', tpShown !== 0);
      m.tpsEmpty.textContent = 'No turning points under this filter.';
      m.empty.toggleAttribute('data-hide', !(showLedger && shown === 0));
      m.empty.textContent = 'Nothing this month matches.';
      m.cnt.textContent = filtering ? shown + ' of ' + m.total : String(m.total);
      if (m.btn) {
        m.btn.toggleAttribute('data-hide', filtering);
        m.btn.textContent = m.open ? 'Hide the day-by-day list' : 'Show all ' + m.total + ' entries, day by day';
      }
      return shown;
    }

    // ---------- threads
    let tabEls = [], panelEls = [];
    function renderThreads() {
      const sec = h('section', 'mlx-block mlx-threads'); sec.setAttribute('aria-labelledby', 'mlx-threads-h');
      const head = h('div', 'mlx-head');
      const t = h('h3', null, 'Stories that ran for weeks.'); t.id = 'mlx-threads-h';
      head.append(h('p', 'mlx-eyebrow', 'Follow a story'), t, h('p', null, 'Each thread pulls the related entries into one timeline. Filters dim what falls outside them.'));
      sec.append(head);
      const tabs = h('div', 'mlx-tabs'); tabs.setAttribute('role', 'tablist'); tabs.setAttribute('aria-label', 'Stories');
      sec.append(tabs);
      D.threads.forEach((th, k) => {
        const tab = h('button', 'mlx-tab'); tab.type = 'button'; tab.id = 'mlx-tab-' + th.key;
        tab.setAttribute('role', 'tab'); tab.setAttribute('aria-controls', 'mlx-tpanel-' + th.key);
        tab.setAttribute('aria-selected', k === 0 ? 'true' : 'false'); tab.tabIndex = k === 0 ? 0 : -1;
        tab.append(document.createTextNode(th.name), h('i', null, String(th.ids.length + th.earlier.length)));
        tab.addEventListener('click', () => selectTab(k));
        tab.addEventListener('keydown', ev => {
          const d = ev.key === 'ArrowRight' ? 1 : ev.key === 'ArrowLeft' ? -1 : 0;
          if (d) { ev.preventDefault(); const n = (k + d + D.threads.length) % D.threads.length; selectTab(n); tabEls[n].focus(); }
        });
        tabs.append(tab); tabEls.push(tab);
        const panel = h('div', 'mlx-tpanel'); panel.id = 'mlx-tpanel-' + th.key;
        panel.setAttribute('role', 'tabpanel'); panel.setAttribute('aria-labelledby', tab.id); panel.tabIndex = 0;
        if (k) panel.hidden = true;
        panel.append(h('p', 'mlx-tsum', th.sum));
        const ol = h('ol', 'mlx-tl');
        th.earlier.forEach(([when, title, org, url]) => {
          const li = h('li', 'is-earlier');
          const b = h('div', 'mlx-tl-body'); b.append(ext(h('a', null, title), url));
          const f = h('p', 'mlx-foot'); f.append(h('span', 'mlx-org', org), badges(url, title)); b.append(f);
          li.append(h('span', 'mlx-tl-when', when), b); ol.append(li);
        });
        th.ids.forEach(i => {
          const e = E[i], d = parseDay(e.date);
          const li = h('li'); li.dataset.i = i;
          const b = h('div', 'mlx-tl-body'); b.append(ext(h('a', null, e.title), e.url));
          const f = h('p', 'mlx-foot'); f.append(...metaFor(e, true).childNodes); b.append(f);
          li.append(h('span', 'mlx-tl-when', d.mon + ' ' + d.d), b); ol.append(li);
        });
        panel.append(ol);
        sec.append(panel); panelEls.push(panel);
      });
      return sec;
    }
    function selectTab(k) {
      tabEls.forEach((t, j) => { t.setAttribute('aria-selected', j === k ? 'true' : 'false'); t.tabIndex = j === k ? 0 : -1; });
      panelEls.forEach((p, j) => { p.hidden = j !== k; });
    }
    function applyThreads() {
      panelEls.forEach(p => p.querySelectorAll('li[data-i]').forEach(li => li.classList.toggle('is-dim', !visible(E[+li.dataset.i]))));
    }

    // ---------- then and now
    function renderThen() {
      const sec = h('section', 'mlx-block mlx-then'); sec.setAttribute('aria-labelledby', 'mlx-then-h');
      const head = h('div', 'mlx-head');
      const t = h('h3', null, 'What was impossible last year may be viable now.'); t.id = 'mlx-then-h';
      head.append(h('p', 'mlx-eyebrow', 'Then and now'), t, h('p', null, 'Three capabilities traced through the archive, from their first entry to this fall.'));
      sec.append(head);
      const tracks = h('div', 'mlx-tracks');
      D.tracks.forEach(tr => {
        const box = h('div', 'mlx-track mlx-panel');
        box.append(h('h4', null, tr.name));
        const ol = h('ol', 'mlx-steps');
        tr.nodes.forEach(([when, title, org, url, idx]) => {
          const li = h('li', 'mlx-step' + (idx >= 0 ? ' is-new' : ''));
          li.append(h('span', 'mlx-step-when', when), ext(h('a', null, title), url), h('span', 'mlx-org', org));
          ol.append(li);
        });
        box.append(ol);
        tracks.append(box);
      });
      sec.append(tracks);
      const apart = h('div', 'mlx-apart');
      const M0 = D.months[0], [ly, lm] = M0.key.split('-').map(Number);
      const inMonth = D.days.filter(([iso]) => iso.startsWith(M0.key + '-')).map(([iso]) => parseDay(iso).d);
      const d0 = Math.min(...inMonth), d1 = Math.max(...inMonth);
      const wholeMonth = d0 === 1 && d1 === new Date(Date.UTC(ly, lm, 0)).getUTCDate();
      const a1 = h('div', 'mlx-panel'); a1.append(h('h4', null, MONTH_LONG[lm - 1] + ' ' + (ly - 1)));
      const u1 = h('ul');
      D.oct25.forEach(([title, org, url]) => { const li = h('li'); li.append(ext(h('a', null, title), url), h('span', 'mlx-org', org)); u1.append(li); });
      a1.append(u1);
      const a2 = h('div', 'mlx-panel'); a2.append(h('h4', null, MONTH_LONG[lm - 1] + ' ' + (wholeMonth ? '' : d0 + ' to ' + d1 + ', ') + ly));
      const u2 = h('ul');
      (D.tpOrder[M0.key] || []).forEach(i => { const e = E[i]; const li = h('li'); li.append(ext(h('a', null, e.title), e.url), h('span', 'mlx-org', e.org)); u2.append(li); });
      a2.append(u2);
      apart.append(a1, a2);
      sec.append(h('p', 'mlx-sub', 'A year apart'), apart);
      return sec;
    }

    // The full, independently searchable record is rendered by deepmoat-memory-archive.liquid below.
    function renderArchiveLink() {
      const p = h('p', 'mlx-archive-link');
      const a = h('a', null, 'Explore all ' + D.total + ' entries in the full memory →');
      a.href = '#memory-archive';
      p.append(a);
      return p;
    }

    // ---------- filters applied everywhere
    function apply(fromLens) {
      let total = 0;
      Object.keys(monthEls).forEach(k => { total += applyMonth(k); });
      updateWeek();
      applyThreads();
      D.days.forEach(([iso]) => {
        const b = mount.querySelector('.mlx-bar[data-day="' + iso + '"]');
        const any = E.some(e => e.date === iso && visible(e));
        b.classList.toggle('is-dim', (state.lens !== 'all' || !!state.q) && !any);
      });
      updateLensLine(total);
      if (fromLens && lensStuck()) {
        const first = mount.querySelector('.mlx-week');
        window.scrollTo({ top: first.getBoundingClientRect().top + window.scrollY - headerOffset() - lensBar.offsetHeight - 12 });
      }
    }
    const headerOffset = () => { const hd = document.querySelector('.site-header, header'); return hd ? Math.max(0, hd.getBoundingClientRect().bottom) : 0; };
    const lensStuck = () => lensBar.getBoundingClientRect().top <= headerOffset() + 1 && window.scrollY > 0 && mount.querySelector('.mlx-week').getBoundingClientRect().top < headerOffset() + lensBar.offsetHeight;
    function jumpToDay(iso) {
      const key = iso.slice(0, 7);
      if (monthEls[key] && !monthEls[key].open && state.lens === 'all' && !state.q) setOpen(key, true);
      const g = document.getElementById('mlx-d-' + iso);
      if (!g) return;
      if (g.hasAttribute('data-hide')) {
        state.lens = 'all'; state.q = '';
        chipsEl.querySelectorAll('.mlx-chip').forEach(c => c.setAttribute('aria-pressed', c.dataset.lens === 'all' ? 'true' : 'false'));
        searchLabel.querySelector('input').value = '';
        apply(false);
      }
      // Two frames later, so any focus handling from the click has settled before the page moves.
      requestAnimationFrame(() => requestAnimationFrame(() => {
        const y = g.getBoundingClientRect().top + window.scrollY - headerOffset() - lensBar.offsetHeight - 12;
        window.scrollTo({ top: y, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        g.focus({ preventScroll: true });
        g.classList.add('is-flash'); setTimeout(() => g.classList.remove('is-flash'), 1800);
      }));
    }

    // ---------- build
    const frag = document.createDocumentFragment();
    frag.append(renderPulse());
    frag.append(...renderLens(), renderWeek());
    D.months.forEach(M => frag.append(renderMonth(M)));
    frag.append(renderThreads(), renderThen(), renderArchiveLink());
    mount.textContent = '';
    mount.append(frag);
    let lastTop = -1, topQueued = false;
    const setTop = () => { topQueued = false; const t = Math.round(headerOffset()); if (t !== lastTop) { lastTop = t; root.style.setProperty('--mlx-top', t + 'px'); } };
    const queueTop = () => { if (!topQueued) { topQueued = true; requestAnimationFrame(setTop); } };
    setTop();
    addEventListener('resize', queueTop, { passive: true });
    addEventListener('scroll', queueTop, { passive: true });
    const edge = el => { const f = () => { el.classList.toggle('is-more', el.scrollWidth > el.clientWidth + 2); el.classList.toggle('is-end', el.scrollLeft + el.clientWidth >= el.scrollWidth - 2); }; f(); el.addEventListener('scroll', f, { passive: true }); addEventListener('resize', f, { passive: true }); };
    edge(chipsEl); mount.querySelectorAll('.mlx-tabs').forEach(edge);
    apply(false);

  }
})();
